/**
 * Extract 1-2 character initials from a free-form string. Handles email
 * addresses (drops the `@domain` part), display names with separators
 * (`first.last`, `First-Last`, `First_Last`, `First Last`), and single
 * tokens. Returns `?` for empty input. Always upper-cased.
 */
export function initialsFor(source: string | null | undefined): string {
  const trimmed = (source ?? '').trim();
  if (!trimmed) return '?';
  const parts = trimmed.replace(/@.*/u, '').split(/[\s._-]+/u).filter(Boolean);
  if (parts.length === 0) return trimmed.slice(0, 1).toUpperCase();
  const first = parts[0]?.[0] ?? '';
  const second = parts[1]?.[0] ?? '';
  return (first + second).toUpperCase() || trimmed.slice(0, 1).toUpperCase();
}
